<template>
  <BaseButton primary outline small class="w-full" @click="open">
    <span class="truncate"> Import Category </span>
  </BaseButton>
</template>

<script>
import { accountTagCategoryTemplateImportsClient } from '@/api/clients';

export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showForm: false,
    };
  },
  methods: {
    async open() {
      this.$modal.show({
        component: () => import('@/components/TagCategory/TagCategoryTemplateImportModal.vue'),
        props: {
          action: this.importTagCategoryTemplate,
        },
        on: {
          'tag-category-template-imported': (importedTagCategory) => {
            this.$emit('tag-category-imported', importedTagCategory);
          },
        },
        hideEvent: 'hide',
      });
    },
    importTagCategoryTemplate(formData) {
      return accountTagCategoryTemplateImportsClient.template(this.accountId, formData);
    },
  },
};
</script>
